// Этот файл генерируется автоматически, его не следует редактировать вручную
import form from '@/widgets/form.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import menuSubmenu from '@/widgets/menuSubmenu.js';
import mobileHeader from '@/widgets/mobileHeader.js';
import popup from '@/widgets/popup.js';
import requestPopup from '@/widgets/requestPopup.js';
import scrollTop from '@/widgets/scrollTop.js';
import selectNotEmpty from '@/widgets/selectNotEmpty.js';
import showPopupMenu from '@/widgets/showPopupMenu.js';
import toggleClass from '@/widgets/toggleClass.js';

export default {
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'documentsCarousel': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/documentsCarousel.js'),
  'folder': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/folder.js'),
  'form': async () => { return { default: form }; },
  'formsConditional': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/formsConditional.js'),
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'menuSubmenu': async () => { return { default: menuSubmenu }; },
  'mobileHeader': async () => { return { default: mobileHeader }; },
  'popup': async () => { return { default: popup }; },
  'requestPopup': async () => { return { default: requestPopup }; },
  'reviewsCarousel': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/reviewsCarousel.js'),
  'scrollTop': async () => { return { default: scrollTop }; },
  'scrollWatcher': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollWatcher.js'),
  'selectNotEmpty': async () => { return { default: selectNotEmpty }; },
  'showPopupMenu': async () => { return { default: showPopupMenu }; },
  'signedForm': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "signedForm" */ '@/widgets/signedForm.js'),
  'telField': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/telField.js'),
  'toggleClass': async () => { return { default: toggleClass }; },
  'upload': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/upload.js')
};
